module.exports = {
      id: "icon-gift-received-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#icon-gift-received",
      toString: function () {
        return this.url;
      }
    }